// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("bs-platform/lib/js/array.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");

function render_string(prim) {
  return prim;
}

function render_array(prim) {
  return prim;
}

var render_list = $$Array.of_list;

function hd(touchlist) {
  return Caml_array.caml_array_get(touchlist, 0);
}

var $$TouchList = /* module */[/* hd */hd];

var Env = /* module */[];

exports.render_string = render_string;
exports.render_array = render_array;
exports.render_list = render_list;
exports.$$TouchList = $$TouchList;
exports.Env = Env;
/* No side effect */
